import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { MessageToastWebElement } from './MessageToastWebElement';
export { MessageToastWebElement };

/**
 * Retrieve an instance of [MessageToastWebElement](../classes/MessageToastWebElement.html).
 * @example
 * ```javascript
 * import { findMessageToast } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findMessageToast(driver, By.id('my-oj-c-message-toast'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findMessageToast(
  driver: DriverLike,
  by: By
): Promise<MessageToastWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type MessageToastWebElement
  if (!(webEl instanceof MessageToastWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'MessageToastWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findMessageToast(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${MessageToastWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-message-toast', MessageToastWebElement);
